import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    GOOGLE_TOTP: 'gotp',
    OKTA_TOTP: 'ootp',
    PUSH: 'opush'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
